import UserNameFormat from "../util/UserNameFormat";

export default class User
{
    constructor(id, firstName, lastName, middleName, username, active, emailExists, userGroupId, timeZoneGroupId, isPTO, isSick, isOvertimeTracking, overtimeTrackingLevel)
    {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.middleName = middleName;
        this.username = username;
        this.active = active;
        this.emailExists = emailExists;
        this.userGroupId = userGroupId;
        this.timeZoneGroupId = timeZoneGroupId;
        this.isPTO = isPTO
        this.isSick = isSick
        this.isOvertimeTracking = isOvertimeTracking
        this.overtimeTrackingLevel = overtimeTrackingLevel
    }

    isActive()
    {
        return this.active;
    }

    formatNameFMLU()
    {
        return UserNameFormat.formatFMLU(this.firstName, this.lastName, this.middleName, this.username);
    }

    formatNameFML()
    {
        return UserNameFormat.formatFML(this.firstName, this.lastName, this.middleName);
    }

    formatNameLFMU()
    {
        return UserNameFormat.formatLFMU(this.firstName, this.lastName, this.middleName, this.username);
    }

    formatNameLFM()
    {
        return UserNameFormat.formatLFM(this.firstName, this.lastName, this.middleName);
    }

    getUserGroupId()
    {
        return this.userGroupId;
    }

    getTimeZoneGroupId()
    {
        return this.timeZoneGroupId;
    }

    clone()
    {
        return new User(
                this.id,
                this.firstName,
                this.lastName,
                this.middleName,
                this.username,
                this.active,
                this.emailExists,
                this.userGroupId,
                this.timeZoneGroupId,
                this.isPTO,
                this.isSick,
                this.isOvertimeTracking,
                this.overtimeTrackingLevel
            );
    }

    hasEmail()
    {
        return this.emailExists;
    }

    setRequiresTTApproval(isRequiresTTApproval)
    {
        this.isRequiresTTApproval = isRequiresTTApproval;
    }
}




// WEBPACK FOOTER //
// ./web/js/store/User.js